<template>
  <v-col>
    <!-- Projects -->
    <v-row v-if="haveProjects">
      <v-col>
        <!-- Search -->
        <v-row>
          <v-col>
            <v-text-field
              v-model="searchTerm"
              label="Search"
              dense
              single-line
              outlined
              hide-details
            />
          </v-col>
        </v-row>

        <!-- Active Projects -->
        <v-row>
          <v-col>
            <!-- Toggle Group -->
            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <!-- Toggle Group -->
                    <font-awesome-icon
                      :icon="['fas', showActiveProject ? 'chevron-down' : 'chevron-right']"
                      size="xs"
                      class="gray--text cursor-pointer"
                      @click.stop="toggleActiveProjects"
                    />

                    <span
                      class="pl-1 subtitle-1 font-weight-medium cursor-pointer"
                      @click.stop="toggleActiveProjects"
                    >Active</span>

                    <!-- Total Projects -->
                    <v-chip
                      class="ml-2"
                      x-small
                    >
                      {{ activeProjects.length }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="showActiveProject">
              <v-col>
                <v-row
                  v-for="project in activeProjects"
                  :key="project.projectId"
                >
                  <v-col>
                    <v-card
                      class="px-3 pt-3 pb-6 elevation-0"
                    >
                      <v-card-title class="subtitle-1 font-weight-bold darkblue--text">
                        <v-col>
                          <v-row>
                            <v-col
                              class="pb-0 col-auto text-truncate"
                              :title="project.projectName"
                            >
                              <span
                                class="cursor-pointer"
                                @click="goToProject(project)"
                              >
                                {{ project.projectName }}
                              </span>
                            </v-col>

                            <v-col class="col-auto pb-0 px-0 midgray--text">
                              <!-- Status -->
                              <v-chip
                                :class="`ml-2 ${project.projectStatusColorText}--text`"
                                :color="project.projectStatusColorBackground"
                                small
                              >
                                {{ project.projectStatus }}
                              </v-chip>
                            </v-col>

                            <v-spacer />

                            <v-col class="col-auto pb-0 px-0 midgray--text">
                              <!-- Actions -->
                              <v-menu
                                offset-y
                                bottom
                              >
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    v-on="on"
                                  >
                                    <font-awesome-icon
                                      :icon="['fas', 'ellipsis-vertical']"
                                      size="lg"
                                    />
                                  </v-btn>
                                </template>

                                <v-list>
                                  <v-list-item
                                    v-for="action in actions"
                                    :key="action.name"
                                    @click="action.event(project)"
                                  >
                                    <v-list-item-title>{{ action.name }}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col class="pt-0">
                              <v-row class="body-2 mt-0">
                                <v-col class="col-auto py-0 font-weight-medium nearblack--text">
                                  {{ project.projectCode || 'Code TBD' }}
                                </v-col>

                                <v-col class="col-auto pa-0">
                                  <font-awesome-icon
                                    :icon="['fas', 'circle']"
                                    size="xs"
                                    class="px-1 midgray--text"
                                    style="font-size: 6px; margin-bottom: 1.5px;"
                                  />
                                </v-col>

                                <v-col class="col-auto py-0 font-weight-medium nearblack--text">
                                  {{ project.projectType || 'Type TBD' }}
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-card-title>

                      <v-card-text>
                        <v-col>
                          <v-row>
                            <v-col>
                              <v-row class="subtitle-2">
                                <v-col class="midgray--text">
                                  Description
                                </v-col>
                              </v-row>

                              <v-row class="body-2 mt-0">
                                <v-col class="pt-0 font-weight-medium nearblack--text">
                                  {{ project.projectDescription }}
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>

                          <!-- Progress Bar -->
                          <v-row>
                            <v-col>
                              <v-row class="subtitle-2">
                                <v-col class="pb-0">
                                  <span class="nearblack--text">{{ project.totalBillableTimeFormatted }}</span>
                                  <span class="px-1 midgray--text">/</span>
                                  <span class="nearblack--text">{{ project.projectHoursFormatted }}</span>
                                  <span class="pl-1 midgray--text">Hrs Consumed</span>
                                </v-col>

                                <v-col class="pb-0 midgray--text text-right">
                                  <span class="pr-1 nearblack--text">{{ project.projectMinutesConsumedPercentFormatted }}%</span>
                                  <span class="midgray--text">Hrs Consumed</span>
                                </v-col>
                              </v-row>

                              <v-row
                                class="body-2 mt-0"
                                @click="showTimeEntries(project)"
                              >
                                <v-col class="font-weight-medium nearblack--text">
                                  <div
                                    class="icewhite"
                                    style="width: 100%;"
                                  >
                                    <div
                                      :class="project.projectStatusColorBackground"
                                      :style="`height: 8px; width: ${ project.projectMinutesConsumedPercentage }%;`"
                                    />
                                  </div>
                                </v-col>
                              </v-row>

                              <v-row class="mt-0">
                                <v-col>
                                  <v-divider />
                                </v-col>
                              </v-row>

                              <v-row class="mt-0 subtitle-2">
                                <v-col class="col-auto">
                                  <span class="nearblack--text">{{ project.startDateFormatted || '--' }}</span>
                                  <span class="px-1 midgray--text">to</span>
                                  <span class="nearblack--text">{{ project.endDateFormatted || '--' }}</span>
                                </v-col>

                                <v-col class="text-right">
                                  <span class="pr-1 nearblack--text">{{ project.projectDaysRemaining }}</span>
                                  <span class="midgray--text">Days Remaining</span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Divider -->
        <v-row>
          <v-col>
            <v-divider />
          </v-col>
        </v-row>

        <!-- Inactive Projects -->
        <v-row v-if="inactiveProjects.length > 0">
          <v-col>
            <v-row>
              <v-col>
                <!-- Toggle Group -->
                <font-awesome-icon
                  :icon="['fas', showActiveProject ? 'chevron-down' : 'chevron-right']"
                  size="xs"
                  class="gray--text cursor-pointer"
                  @click.stop="toggleActiveProjects"
                />

                <span
                  class="pl-1 subtitle-1 font-weight-medium cursor-pointer"
                  @click.stop="toggleActiveProjects"
                >Inactive</span>

                <!-- Total Projects -->
                <v-chip
                  class="ml-2"
                  x-small
                >
                  {{ inactiveProjects.length }}
                </v-chip>
              </v-col>
            </v-row>

            <v-row
              v-for="project in inactiveProjects"
              :key="project.projectId"
            >
              <v-col>
                <v-card
                  class="px-3 pt-3 pb-6 elevation-0"
                >
                  <v-card-title class="subtitle-1 font-weight-bold darkblue--text">
                    <v-col>
                      <v-row>
                        <v-col
                          class="pb-0 col-auto text-truncate"
                          :title="project.projectName"
                        >
                          <span
                            class="cursor-pointer"
                            @click="goToProject(project)"
                          >
                            {{ project.projectName }}
                          </span>
                        </v-col>

                        <v-col class="col-auto pb-0 px-0 midgray--text">
                          <!-- Status -->
                          <v-chip
                            :class="`ml-2 ${project.projectStatusColorText}--text`"
                            :color="project.projectStatusColorBackground"
                            small
                          >
                            {{ project.projectStatus }}
                          </v-chip>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="pt-0">
                          <v-row class="body-2 mt-0">
                            <v-col class="col-auto py-0 font-weight-medium nearblack--text">
                              {{ project.projectCode }}
                            </v-col>

                            <v-col class="col-auto py-0 font-weight-medium nearblack--text">
                              {{ project.projectType }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card-title>

                  <v-card-text>
                    <v-col>
                      <v-row>
                        <v-col>
                          <v-row class="subtitle-2">
                            <v-col class="midgray--text">
                              Description
                            </v-col>
                          </v-row>

                          <v-row class="body-2 mt-0">
                            <v-col class="py-0 font-weight-medium nearblack--text">
                              {{ project.projectDescription }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- No Projects -->
    <v-row v-else>
      <v-col>
        <v-card class="px-3 pt-3 pb-6 elevation-0">
          <v-card-text>
            <v-row>
              <v-col>
                <v-row class="subtitle-2">
                  <v-col class="midgray--text">
                    No projects found.
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Show Time Entry View -->
    <v-dialog
      v-model="showTimeEntryView"
      max-width="1200px"
    >
      <v-card>
        <v-card-title class="headline">
          <v-col>
            <v-row>
              <v-col class="col-auto">
                <span>Time Entries</span>
              </v-col>

              <v-col class="text-right">
                <!-- Download Button -->
                <v-btn
                  class="px-3 mx-3"
                  color="primary"
                  :ripple="false"
                  @click.stop="exportTimeEntriesAsCsv(currentProject)"
                >
                  Export
                </v-btn>

                <v-btn
                  :ripple="false"
                  icon
                  @click.stop="closeForm()"
                >
                  <v-icon color="midgray">
                    close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card-title>

        <v-card-text class="font-weight-medium">
          <!-- Table of Time Entries -->
          <v-col>
            <v-row>
              <v-col>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th
                        class="text-left"
                        style="width: 120px;"
                      >
                        Date
                      </th>

                      <th
                        class="text-left"
                        style="width: 180px;"
                      >
                        Person
                      </th>

                      <th class="text-left">
                        Team
                      </th>

                      <th class="text-left">
                        Description
                      </th>

                      <th class="text-left">
                        Minutes
                      </th>

                      <th class="text-left">
                        Billable Minutes
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="entry in currentTimeEntries"
                      :key="entry.id"
                    >
                      <td>{{ entry.timeEntryDateFormatted }}</td>

                      <td>{{ entry.personName }}</td>

                      <td>{{ entry.teamName }}</td>

                      <td>{{ entry.workNote }}</td>

                      <td>{{ entry.actionDuration }}</td>

                      <td>{{ entry.billableActionDuration }}</td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td>Total</td>
                      <td />
                      <td />
                      <td />
                      <td>{{ totalMinutes }}</td>
                      <td>{{ totalBillableMinutes }}</td>
                    </tr>
                  </tfoot>
                </v-simple-table>
              </v-col>
            </v-row>

            <v-row v-if="testingTimeEntries">
              <v-col>
                <pre class="lang-json">
                  <code class="lang-json">
                    {{ currentTimeEntries[0] }}
                  </code>
                </pre>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>

        <v-card-actions class="pb-4">
          <v-spacer />

          <v-btn
            color="primary"
            text
            @click="hideTimeEntries"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import dates from 'src/utils/dates'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'Projects',
  data() {
    return {
      // Data Tools
      searchTerm: '',

      // Flags
      showActiveProject: true,
      testingTimeEntries: false,

      // Time Entry View
      currentProject: {},
      currentTimeEntries: [],
      showTimeEntryView: false,
      sortDirectionForTimeEntries: 'DSC',
      totalMinutes: 0,
      totalBillableMinutes: 0,

      timeSortByKeys: [
        {
          key: 'timeEntryDate',
          direction: 'DSC',
        },
        {
          key: 'personName',
          direction: 'ASC',
        },
      ],
    }
  },
  computed: {
    ...mapAuthGetters([
      'isUserInternalAdmin',
    ]),
    ...mapToolsGetters([
      'projects',
      'projectTimeColumns',
    ]),

    $projects() {
      const getUndeletedProjects = (projects) => projects.filter((project) => !project.isDeleted)

      return Array.isArray(this.projects) ? getUndeletedProjects(this.projects) : []
    },

    haveProjects() {
      return this.$projects.length > 0
    },

    projectsCollection() {
      if (this.searchTerm.length > 0) {
        const searchTerm = this.searchTerm.toLowerCase()

        return this.$projects.filter((project) => {
          const projectName = (project.projectName || '').toLowerCase()
          const projectCode = (project.projectCode || '').toLowerCase()
          const projectType = (project.projectType || '').toLowerCase()
          const projectDescription = (project.projectDescription || '').toLowerCase()
          const projectStatus = project.projectStatus.toLowerCase()
          const startDateFormatted = project.startDateFormatted.toLowerCase()
          const endDateFormatted = project.endDateFormatted.toLowerCase()
          const createdDateFormatted = project.createdDateFormatted.toLowerCase()
          const updatedDateFormatted = project.updatedDateFormatted.toLowerCase()

          return (
            projectName.indexOf(searchTerm) > -1
            || projectCode.indexOf(searchTerm) > -1
            || projectType.indexOf(searchTerm) > -1
            || projectDescription.indexOf(searchTerm) > -1
            || projectStatus.indexOf(searchTerm) > -1
            || startDateFormatted.indexOf(searchTerm) > -1
            || endDateFormatted.indexOf(searchTerm) > -1
            || createdDateFormatted.indexOf(searchTerm) > -1
            || updatedDateFormatted.indexOf(searchTerm) > -1
          )
        })
      }

      return this.$projects
    },

    activeProjects() {
      return this.projectsCollection.filter((project) => project.isActive)
    },

    inactiveProjects() {
      return this.projectsCollection.filter((project) => !project.isActive)
    },

    actions() {
      return [
        {
          event: (project) => this.$store.dispatch('internal/onEditProject', project),
          name: 'Edit',
        },
        {
          event: (project) => this.$store.dispatch('internal/onDeleteProject', project),
          name: 'Delete',
        },
      ]
    },
  },

  methods: {
    goToProject(project) {
      this.$store.dispatch('internal/goToProject', project)
    },

    sortTimeEntriesByDateAsc(a, b) {
      return new Date(a.timeEntryDate) - new Date(b.timeEntryDate)
    },
    sortTimeEntriesByDateDsc(a, b) {
      return new Date(b.timeEntryDate) - new Date(a.timeEntryDate)
    },
    sortTimeEntriesByAsc(key) {
      if (key === 'timeEntryDate') {
        return this.sortTimeEntriesByDateAsc
      }

      return (a, b) => {
        if (a[key] < b[key]) {
          return -1
        }

        if (a[key] > b[key]) {
          return 1
        }

        return 0
      }
    },
    sortTimeEntriesByDsc(key) {
      if (key === 'timeEntryDate') {
        return this.sortTimeEntriesByDateDsc
      }

      return (a, b) => {
        if (a[key] > b[key]) {
          return -1
        }

        if (a[key] < b[key]) {
          return 1
        }

        return 0
      }
    },

    sortTimeEntries({ direction, key }) {
      return (a, b) => {
        if (direction === 'ASC') {
          return this.sortTimeEntriesByAsc(key)(a, b)
        }

        return this.sortTimeEntriesByDsc(key)(a, b)
      }
    },

    toggleActiveProjects() {
      this.showActiveProject = !this.showActiveProject
    },

    /**
     * @method showTimeEntries
     * @desc Set the view's data before revealing the view to the user.
     * @param {Object} project
     * @param {Promise} project.timeEntries
     * @return {void}
     */
    async showTimeEntries(project) {
      // Set the selected project on the view.
      this.currentProject = project

      // Get the project's time entries.
      const currentTimeEntries = await project.timeEntries

      /**
       * Sort the view's time entries by date.
       * Set the sorted time entries on the view.
       *
       * Apply the sorting configurations in reverse order
       * to ensure the user's latest sort order overrides
       * all previous sort orders.
       */

      // eslint-disable-next-line arrow-body-style
      this.currentTimeEntries = this.timeSortByKeys.reduceRight((sortedArray, sortingConfig) => {
        /**
         * @const {function} sortByKeyAndDirection
         * @desc A function configured with a key and direction to sort by.
         */
        const sortByKeyAndDirection = this.sortTimeEntries(sortingConfig)

        // Return the sorted array.
        return sortedArray.sort(sortByKeyAndDirection)
      }, currentTimeEntries)

      // Set the view's calculations.
      this.totalMinutes = this.currentTimeEntries.reduce((sum, entry) => sum + entry.actionDuration, 0)
      this.totalBillableMinutes = this.currentTimeEntries.reduce((sum, entry) => sum + entry.billableActionDuration, 0)

      // Reveal the view.
      this.showTimeEntryView = true
    },

    /**
     * @method hideTimeEntries
     * @desc Hide the view from the user before resetting the view's data.
     * @return {void}
     */
    hideTimeEntries() {
      // Hide the view.
      this.showTimeEntryView = false

      // Reset the view's data.
      this.currentProject = {}
      this.currentTimeEntries = []

      // Reset the view's calculations.
      this.totalMinutes = 0
      this.totalBillableMinutes = 0
    },

    exportTimeEntriesAsCsv(project) {
      const {
        currentTimeEntries,
        projectTimeColumns: exportColumns,
        timeSortByKeys: sortByKeys,
      } = this

      const { projectCode } = project

      const todayFormatted = dates.getFormattedDate(undefined, 'YYYY-MM-DD')

      const exportFormat = 'csv'
      const exportName = 'time-entries'
      const exportFileName = `Time Entries for ${projectCode} (Extracted ${todayFormatted})`

      const exportGroups = [
        {
          items: currentTimeEntries,
        },
      ]

      const configExport = {
        exportColumns,
        exportFileName,
        exportFormat,
        exportGroups,
        exportName,
        sortByKeys,
      }

      return this.$store.dispatch('tools/exportAs', configExport)
    },
  },
}
</script>
